/* Extracts a YouTube channel ID from various URL formats.
   Used for duplicate detection when importing YouTube subscriptions. */

const CHANNEL_ID_REGEX = /^UC[a-zA-Z0-9_-]{22}$/;

export function extractYouTubeChannelId(url: string): string | null {
  const channelMatch = url.match(/channel\/([a-zA-Z0-9_-]+)/);
  if (channelMatch) return channelMatch[1];

  if (CHANNEL_ID_REGEX.test(url)) return url;

  return null;
}
